import { render, staticRenderFns } from "./PopupV2.vue?vue&type=template&id=467389a4"
import script from "./PopupV2.vue?vue&type=script&lang=js"
export * from "./PopupV2.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/app.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/css/unique.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports